export default "__VITE_ASSET__YYuvZfYX__"